import React from 'react'
import styles from "./ChatWidget.module.scss"
import clsx from 'clsx'
import { Loader } from '@mantine/core'

const ChatTyping = () => {
    return (
        <div className={clsx(styles.message, styles.typing
        )}>

            <div className={styles["message-content"]}>
                <Loader color="blue" size="sm" />
            </div>
        </div>
    )
}

export default ChatTyping